<div *ngIf="type==1" >
<div class="border" *ngIf="reviewDetail.length>0">
    <div class="padding-10 backg" fxLayout="row">
      <b class="f20">Reviews & Ratings
      </b>
    </div>
    <mat-divider></mat-divider>
    <div>
      <div *ngFor="let item of reviewDetail" class="bordert padding-10 backg">

        <div class="padding-tb10" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
          <div class="review-Rating E_uFuv">
            {{item.ratingOptionVote[0].value}}
            <span class="material-icons f11">
              star_rate
            </span>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <span class="icon_color1"><b>{{item.reviewDetail.title | titlecase }}</b></span>
          </div>
        </div>
        <div class="padding-tb10" fxLayout="row" fxLayoutAlign="start center">
          <span class="icon_color1">{{item.reviewDetail.detail | titlecase }}</span>
        </div>
        <div *ngIf="reviewDetail?.length==0" class="border padding-10">
          <div class="padding-tb10" fxLayout="row" fxLayoutAlign="start center">
            <span class="icon_color1">No Review Found</span>
          </div>
        </div>

      </div>
    </div>
  </div></div>

  <div *ngIf="type==2">
  <div class="full-desc lh">
    <div *ngFor="let item of reviewDetail" class="border padding-10">
       <div class="padding-tb10" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
         <div class="review-Rating E_uFuv">
           {{item.ratingOptionVote[0].value}}
           <span class="material-icons f11">
             star_rate
           </span>
         </div>
         <div fxLayout="row" fxLayoutAlign="start center">
           <span class="icon_color1"><b>{{item.reviewDetail.title | titlecase | uppercase }}</b></span>
         </div>
       </div>
       <div class="padding-tb10" fxLayout="row" fxLayoutAlign="start center">
         <span class="icon_color1">{{item.reviewDetail.detail | titlecase }}</span>
       </div>
       <div *ngIf="reviewDetail?.length==0" class="border padding-10">
         <div class="padding-tb10" fxLayout="row" fxLayoutAlign="start center">
           <span class="icon_color1">No Review Found</span>
         </div>
       </div>
     </div> 
    
   </div>
   </div>